import { DlrThemeProvider } from '@dxm/shared-components';
import { Box, styled } from '@mui/material';

import bgImg from './assets/bg_img.png';
import RegistrationCard from './components/RegistrationCard.js';
import { RegistrationProvider } from './contexts/RegistrationContext.js';

const PageContainer = styled(Box)({
  alignItems: 'center',
  backgroundImage: `url(${bgImg})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '100vh',
  padding: '20px',
});

const CustomRegister = () => (
  <DlrThemeProvider>
    <RegistrationProvider>
      <PageContainer>
        <RegistrationCard />
      </PageContainer>
    </RegistrationProvider>
  </DlrThemeProvider>
);

export default CustomRegister;
